import React, { Component } from 'react';
import {List, Flex, Toast} from 'antd-mobile';
import LinkText from './components/link';
import Table from '../../components/Table';
import send from '../../utils/send';
import F2 from '@antv/f2'
import {FARM_ORG, ORG_CODE} from '../../cache';
import df from 'dateformat';
import Location from './components/location';
import DatePickerSE from './components/date-picker-view';
import EmptyReport from '../../components/EmptyReport';

let day = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;

export default class Report11 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      showLoc: false,
      showAbort: false,
      showStart: false,
      showEnd: false,
      parLocation: 'ALL',
      parRemovalType: 'ALL',
      startDate: new Date(day),
      endDate: new Date(),
      tableData: [],
      columns: [
        {
          id: 'parity',
          title: '胎次',
          align: 'left'
        },
        {
          id: 'qty',
          title: '母猪数量',
          align: 'center'
        },
        {
          id: 'percent_rate',
          title: '百分比',
          render (data) {
            return data['percent_rate'] + '%'
          }
        }
      ]
    }
  }
  componentDidMount() {
    this.doSearch()
  }
  doSearch = () => {
    Toast.loading('请稍后', 0);
    const {parLocation, parRemovalType,startDate,endDate} = this.state;
    let start = startDate;
    let end = endDate;
    if (startDate > endDate) {
      start = endDate;
      end = startDate;
      this.setState({startDate: start, endDate: end})
    }
    send({
      url: '/api/forward/ifarm/report12',
      method: 'POST',
      data: {
        orgCode: ORG_CODE,
        farmOrg: FARM_ORG,
        startDate: df(start, 'yyyy-mm-dd'),
        endDate: df(end, 'yyyy-mm-dd'),
        parLocation,
        parRemovalType
      }
    }).then(res => {
      Toast.hide();
      if (!(res.data instanceof Array)) {
        return
      }
      let resData = res.data;
      this.setState({
        tableData: resData
      });
      if (res.data.length < 2) {
        return;
      }
      this.renderChart(resData.slice(0,resData.length - 1))
    }).catch(() => {
      Toast.hide()
    })
  };
  renderChart = (data) => {
    if (this.chart) {
      this.chart.clear()
    }
    const chart = new F2.Chart({
      id: 'container',
      padding: [60, 'auto', 'auto', '40'],
      pixelRatio: window.devicePixelRatio
    });
    chart.axis('qty', {
      line: {
        stroke: '#eee'
      }
    });
    chart.source(data);
    chart.guide().text({
      position: ['0%', '-4%'],
      content: '母猪数量',
      style: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16,
        fill: '#666'
      },
      offsetY: -30
    });
    data.forEach(item => {
      chart.guide().text({
        position: () => {
          return [item.parity, item.qty]
        },
        content: item.qty,
        offsetY: -7
      })
    });

    chart.tooltip({
      showItemMarker: false,
      showTitle: true,
      onShow: function onShow(ev) {
        const items = ev.items;
        items[0].name = null;
        // items[0].name = items[0].title;
        items[0].value = '母猪数量: ' + items[0].value;
      }
    });
    chart.interval()
      .position('parity*qty')
      .color('#1890FF');
    this.chart = chart;
    chart.render();
  };
  onCancel = () => {
    this.setState({
      showLoc: false,
      showAbort: false,
      showStart: false,
      showEnd: false
    })
  };
 render() {
    const {showLoc, showAbort, showStart, showEnd, parLocation, parRemovalType, startDate, endDate} = this.state;
    const flag = showLoc || showAbort || showStart || showEnd;
  return (
    <div className="oneH">
      <List>
        <Flex className={flag ? 'single-multi-menu-active' : ''}>
          <List.Item className={'single-multi-top-nav-bar'}
              onClick={() => {
            this.setState({
              showLoc: !showLoc,
              showAbort: false,
              showStart: false,
              showEnd: false
            })
          }}
              style={{padding: 0,width: '20vw'}}
          >
            <LinkText show={showLoc}>全部</LinkText>
          </List.Item>
          <List.Item className={'single-multi-top-nav-bar'}
              onClick={() => {
            this.setState({
              showLoc: false,
              showAbort: !showAbort,
              showStart: false,
              showEnd: false
            })
          }}
              style={{padding: 0,width: '20vw'}}
          >
            <LinkText show={showAbort}>类型</LinkText>
          </List.Item>
          <List.Item className={'single-multi-top-nav-bar'}
              onClick={() => {
            this.setState({
              showLoc: false,
              showAbort: false,
              showStart: !showStart,
              showEnd: false
            })
          }}
              style={{padding: 0,width: '30vw'}}
          >
            <LinkText show={showStart}>开始时间</LinkText>
          </List.Item>
          <List.Item className={'single-multi-top-nav-bar'}
              onClick={() => {
            this.setState({
              showLoc: false,
              showAbort: false,
              showStart: false,
              showEnd: !showEnd
            })
          }}
              style={{padding: 0,width: '30vw'}}
          >
            <LinkText show={showEnd}>截止时间</LinkText>
          </List.Item>
        </Flex>
      </List>
      <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
        {
          showLoc ? <Location
              onCancel={this.onCancel}
              onConfirm={(value) => {
                this.onCancel();
              this.setState({
                parLocation: value
              }, () => {
                this.doSearch()
              })
            }}
              value={parLocation}
                    />: null
        }
        {
          showAbort ? <Location
              onCancel={this.onCancel}
              onConfirm={(value) => {
                this.onCancel();
                this.setState({
                showAbort: false,
                parRemovalType: value
              }, () => {
                this.doSearch()
              })
            }}
              type={'removeType'}
              value={parRemovalType}
                      />: null
        }
        {
          showStart ?<DatePickerSE onCancel={this.onCancel}
              onConfirm={(value) => {
                this.onCancel();
                                     this.setState({
                                       showStart: false,
                                       startDate: value
                                     }, () => {
                                       this.doSearch()
                                     })
                                   }}
              value={startDate}
                     /> : null
        }
        {
          showEnd ?<DatePickerSE onCancel={this.onCancel}
              onConfirm={(value) => {
                this.onCancel();
                                   this.setState({
                                     showEnd: false,
                                     endDate: value
                                   }, () => {
                                     this.doSearch()
                                   })
                                 }}
              value={endDate}
                   /> : null
        }
      </div>
      {flag ? <div className="menu-mask"/> : null}
      <List.Item
        className={'span-4'}
        extra={`${df(startDate, 'yyyy-mm-dd')} ~ ${df(endDate, 'yyyy-mm-dd')}`}
      >
        时间范围
      </List.Item>

      {this.state.tableData.length > 0 ? <div>
        <Table columns={this.state.columns}
            data={this.state.tableData}
        />
        <canvas height="350"
                id="container"
                width={document.documentElement.clientWidth}
        />
      </div> : <EmptyReport height={250}
          width={'100vw'}
               />}
    </div>
  )
 }
}
